import React from 'react';
import { Helmet } from 'react-helmet-async';
import { TemplateSuiteId } from 'models/caller';
import { useTemplateSuiteSelector } from 'hooks/caller';
// components
import Navigation, { NavigationTab } from './Navigation';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

interface Props {
  templateSuiteId: TemplateSuiteId;
}

const Component = ({ templateSuiteId }: Props): JSX.Element => {
  const { templateSuite } = useTemplateSuiteSelector(templateSuiteId);
  return (
    <>
      <Helmet><title>{ `Http Template Suite #${ templateSuiteId } ${ templateSuite && templateSuite.name } Statistic` }</title></Helmet>
      <Navigation active={ NavigationTab.STATISTIC } templateSuite={ templateSuite }/>
      { !templateSuite
        ? <Skeleton variant="rect"/>
        : <Typography variant="h4" align="center">Page not implemented</Typography>
      }
    </>

  );
};

export default Component;
